/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const runegambit = $root.runegambit = (() => {

    /**
     * Namespace runegambit.
     * @exports runegambit
     * @namespace
     */
    const runegambit = {};

    runegambit.v1 = (function() {

        /**
         * Namespace v1.
         * @memberof runegambit
         * @namespace
         */
        const v1 = {};

        /**
         * MessageKind enum.
         * @name runegambit.v1.MessageKind
         * @enum {number}
         * @property {number} MESSAGE_KIND_UNSPECIFIED=0 MESSAGE_KIND_UNSPECIFIED value
         * @property {number} TURN_APPLIED=1 TURN_APPLIED value
         * @property {number} STATE_SNAPSHOT=2 STATE_SNAPSHOT value
         * @property {number} ERROR=3 ERROR value
         * @property {number} PING=4 PING value
         * @property {number} PONG=5 PONG value
         * @property {number} EMOTE_SEND=6 EMOTE_SEND value
         * @property {number} EMOTE_RECEIVED=7 EMOTE_RECEIVED value
         */
        v1.MessageKind = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "MESSAGE_KIND_UNSPECIFIED"] = 0;
            values[valuesById[1] = "TURN_APPLIED"] = 1;
            values[valuesById[2] = "STATE_SNAPSHOT"] = 2;
            values[valuesById[3] = "ERROR"] = 3;
            values[valuesById[4] = "PING"] = 4;
            values[valuesById[5] = "PONG"] = 5;
            values[valuesById[6] = "EMOTE_SEND"] = 6;
            values[valuesById[7] = "EMOTE_RECEIVED"] = 7;
            return values;
        })();

        v1.Envelope = (function() {

            /**
             * Properties of an Envelope.
             * @memberof runegambit.v1
             * @interface IEnvelope
             * @property {runegambit.v1.MessageKind|null} [kind] Envelope kind
             * @property {runegambit.v1.ITurnApplied|null} [turnApplied] Envelope turnApplied
             * @property {runegambit.v1.IStateSnapshot|null} [stateSnapshot] Envelope stateSnapshot
             * @property {runegambit.v1.IErrorEnvelope|null} [error] Envelope error
             * @property {runegambit.v1.IPing|null} [ping] Envelope ping
             * @property {runegambit.v1.IPong|null} [pong] Envelope pong
             * @property {runegambit.v1.IEmoteSend|null} [emoteSend] Envelope emoteSend
             * @property {runegambit.v1.IEmoteReceived|null} [emoteReceived] Envelope emoteReceived
             */

            /**
             * Constructs a new Envelope.
             * @memberof runegambit.v1
             * @classdesc Represents an Envelope.
             * @implements IEnvelope
             * @constructor
             * @param {runegambit.v1.IEnvelope=} [properties] Properties to set
             */
            function Envelope(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Envelope kind.
             * @member {runegambit.v1.MessageKind} kind
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.kind = 0;

            /**
             * Envelope turnApplied.
             * @member {runegambit.v1.ITurnApplied|null|undefined} turnApplied
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.turnApplied = null;

            /**
             * Envelope stateSnapshot.
             * @member {runegambit.v1.IStateSnapshot|null|undefined} stateSnapshot
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.stateSnapshot = null;

            /**
             * Envelope error.
             * @member {runegambit.v1.IErrorEnvelope|null|undefined} error
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.error = null;

            /**
             * Envelope ping.
             * @member {runegambit.v1.IPing|null|undefined} ping
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.ping = null;

            /**
             * Envelope pong.
             * @member {runegambit.v1.IPong|null|undefined} pong
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.pong = null;

            /**
             * Envelope emoteSend.
             * @member {runegambit.v1.IEmoteSend|null|undefined} emoteSend
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.emoteSend = null;

            /**
             * Envelope emoteReceived.
             * @member {runegambit.v1.IEmoteReceived|null|undefined} emoteReceived
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Envelope.prototype.emoteReceived = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Envelope payload.
             * @member {"turnApplied"|"stateSnapshot"|"error"|"ping"|"pong"|"emoteSend"|"emoteReceived"|undefined} payload
             * @memberof runegambit.v1.Envelope
             * @instance
             */
            Object.defineProperty(Envelope.prototype, "payload", {
                get: $util.oneOfGetter($oneOfFields = ["turnApplied", "stateSnapshot", "error", "ping", "pong", "emoteSend", "emoteReceived"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Envelope instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {runegambit.v1.IEnvelope=} [properties] Properties to set
             * @returns {runegambit.v1.Envelope} Envelope instance
             */
            Envelope.create = function create(properties) {
                return new Envelope(properties);
            };

            /**
             * Encodes the specified Envelope message. Does not implicitly {@link runegambit.v1.Envelope.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {runegambit.v1.IEnvelope} message Envelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Envelope.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.kind);
                if (message.turnApplied != null && Object.hasOwnProperty.call(message, "turnApplied"))
                    $root.runegambit.v1.TurnApplied.encode(message.turnApplied, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.stateSnapshot != null && Object.hasOwnProperty.call(message, "stateSnapshot"))
                    $root.runegambit.v1.StateSnapshot.encode(message.stateSnapshot, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    $root.runegambit.v1.ErrorEnvelope.encode(message.error, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.ping != null && Object.hasOwnProperty.call(message, "ping"))
                    $root.runegambit.v1.Ping.encode(message.ping, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.pong != null && Object.hasOwnProperty.call(message, "pong"))
                    $root.runegambit.v1.Pong.encode(message.pong, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.emoteSend != null && Object.hasOwnProperty.call(message, "emoteSend"))
                    $root.runegambit.v1.EmoteSend.encode(message.emoteSend, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.emoteReceived != null && Object.hasOwnProperty.call(message, "emoteReceived"))
                    $root.runegambit.v1.EmoteReceived.encode(message.emoteReceived, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Envelope message, length delimited. Does not implicitly {@link runegambit.v1.Envelope.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {runegambit.v1.IEnvelope} message Envelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Envelope.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Envelope message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.Envelope} Envelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Envelope.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.Envelope();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.kind = reader.int32();
                            break;
                        }
                    case 10: {
                            message.turnApplied = $root.runegambit.v1.TurnApplied.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 11: {
                            message.stateSnapshot = $root.runegambit.v1.StateSnapshot.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 12: {
                            message.error = $root.runegambit.v1.ErrorEnvelope.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 13: {
                            message.ping = $root.runegambit.v1.Ping.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 14: {
                            message.pong = $root.runegambit.v1.Pong.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 15: {
                            message.emoteSend = $root.runegambit.v1.EmoteSend.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 16: {
                            message.emoteReceived = $root.runegambit.v1.EmoteReceived.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Envelope message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.Envelope} Envelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Envelope.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Envelope message.
             * @function verify
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Envelope.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                let properties = {};
                if (message.kind != null && message.hasOwnProperty("kind"))
                    switch (message.kind) {
                    default:
                        return "kind: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
                if (message.turnApplied != null && message.hasOwnProperty("turnApplied")) {
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.TurnApplied.verify(message.turnApplied, long + 1);
                        if (error)
                            return "turnApplied." + error;
                    }
                }
                if (message.stateSnapshot != null && message.hasOwnProperty("stateSnapshot")) {
                    if (properties.payload === 1)
                        return "payload: multiple values";
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.StateSnapshot.verify(message.stateSnapshot, long + 1);
                        if (error)
                            return "stateSnapshot." + error;
                    }
                }
                if (message.error != null && message.hasOwnProperty("error")) {
                    if (properties.payload === 1)
                        return "payload: multiple values";
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.ErrorEnvelope.verify(message.error, long + 1);
                        if (error)
                            return "error." + error;
                    }
                }
                if (message.ping != null && message.hasOwnProperty("ping")) {
                    if (properties.payload === 1)
                        return "payload: multiple values";
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.Ping.verify(message.ping, long + 1);
                        if (error)
                            return "ping." + error;
                    }
                }
                if (message.pong != null && message.hasOwnProperty("pong")) {
                    if (properties.payload === 1)
                        return "payload: multiple values";
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.Pong.verify(message.pong, long + 1);
                        if (error)
                            return "pong." + error;
                    }
                }
                if (message.emoteSend != null && message.hasOwnProperty("emoteSend")) {
                    if (properties.payload === 1)
                        return "payload: multiple values";
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.EmoteSend.verify(message.emoteSend, long + 1);
                        if (error)
                            return "emoteSend." + error;
                    }
                }
                if (message.emoteReceived != null && message.hasOwnProperty("emoteReceived")) {
                    if (properties.payload === 1)
                        return "payload: multiple values";
                    properties.payload = 1;
                    {
                        let error = $root.runegambit.v1.EmoteReceived.verify(message.emoteReceived, long + 1);
                        if (error)
                            return "emoteReceived." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an Envelope message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.Envelope} Envelope
             */
            Envelope.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.Envelope)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.Envelope();
                switch (object.kind) {
                default:
                    if (typeof object.kind === "number") {
                        message.kind = object.kind;
                        break;
                    }
                    break;
                case "MESSAGE_KIND_UNSPECIFIED":
                case 0:
                    message.kind = 0;
                    break;
                case "TURN_APPLIED":
                case 1:
                    message.kind = 1;
                    break;
                case "STATE_SNAPSHOT":
                case 2:
                    message.kind = 2;
                    break;
                case "ERROR":
                case 3:
                    message.kind = 3;
                    break;
                case "PING":
                case 4:
                    message.kind = 4;
                    break;
                case "PONG":
                case 5:
                    message.kind = 5;
                    break;
                case "EMOTE_SEND":
                case 6:
                    message.kind = 6;
                    break;
                case "EMOTE_RECEIVED":
                case 7:
                    message.kind = 7;
                    break;
                }
                if (object.turnApplied != null) {
                    if (typeof object.turnApplied !== "object")
                        throw TypeError(".runegambit.v1.Envelope.turnApplied: object expected");
                    message.turnApplied = $root.runegambit.v1.TurnApplied.fromObject(object.turnApplied, long + 1);
                }
                if (object.stateSnapshot != null) {
                    if (typeof object.stateSnapshot !== "object")
                        throw TypeError(".runegambit.v1.Envelope.stateSnapshot: object expected");
                    message.stateSnapshot = $root.runegambit.v1.StateSnapshot.fromObject(object.stateSnapshot, long + 1);
                }
                if (object.error != null) {
                    if (typeof object.error !== "object")
                        throw TypeError(".runegambit.v1.Envelope.error: object expected");
                    message.error = $root.runegambit.v1.ErrorEnvelope.fromObject(object.error, long + 1);
                }
                if (object.ping != null) {
                    if (typeof object.ping !== "object")
                        throw TypeError(".runegambit.v1.Envelope.ping: object expected");
                    message.ping = $root.runegambit.v1.Ping.fromObject(object.ping, long + 1);
                }
                if (object.pong != null) {
                    if (typeof object.pong !== "object")
                        throw TypeError(".runegambit.v1.Envelope.pong: object expected");
                    message.pong = $root.runegambit.v1.Pong.fromObject(object.pong, long + 1);
                }
                if (object.emoteSend != null) {
                    if (typeof object.emoteSend !== "object")
                        throw TypeError(".runegambit.v1.Envelope.emoteSend: object expected");
                    message.emoteSend = $root.runegambit.v1.EmoteSend.fromObject(object.emoteSend, long + 1);
                }
                if (object.emoteReceived != null) {
                    if (typeof object.emoteReceived !== "object")
                        throw TypeError(".runegambit.v1.Envelope.emoteReceived: object expected");
                    message.emoteReceived = $root.runegambit.v1.EmoteReceived.fromObject(object.emoteReceived, long + 1);
                }
                return message;
            };

            /**
             * Creates a plain object from an Envelope message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {runegambit.v1.Envelope} message Envelope
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Envelope.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.kind = options.enums === String ? "MESSAGE_KIND_UNSPECIFIED" : 0;
                if (message.kind != null && message.hasOwnProperty("kind"))
                    object.kind = options.enums === String ? $root.runegambit.v1.MessageKind[message.kind] === undefined ? message.kind : $root.runegambit.v1.MessageKind[message.kind] : message.kind;
                if (message.turnApplied != null && message.hasOwnProperty("turnApplied")) {
                    object.turnApplied = $root.runegambit.v1.TurnApplied.toObject(message.turnApplied, options);
                    if (options.oneofs)
                        object.payload = "turnApplied";
                }
                if (message.stateSnapshot != null && message.hasOwnProperty("stateSnapshot")) {
                    object.stateSnapshot = $root.runegambit.v1.StateSnapshot.toObject(message.stateSnapshot, options);
                    if (options.oneofs)
                        object.payload = "stateSnapshot";
                }
                if (message.error != null && message.hasOwnProperty("error")) {
                    object.error = $root.runegambit.v1.ErrorEnvelope.toObject(message.error, options);
                    if (options.oneofs)
                        object.payload = "error";
                }
                if (message.ping != null && message.hasOwnProperty("ping")) {
                    object.ping = $root.runegambit.v1.Ping.toObject(message.ping, options);
                    if (options.oneofs)
                        object.payload = "ping";
                }
                if (message.pong != null && message.hasOwnProperty("pong")) {
                    object.pong = $root.runegambit.v1.Pong.toObject(message.pong, options);
                    if (options.oneofs)
                        object.payload = "pong";
                }
                if (message.emoteSend != null && message.hasOwnProperty("emoteSend")) {
                    object.emoteSend = $root.runegambit.v1.EmoteSend.toObject(message.emoteSend, options);
                    if (options.oneofs)
                        object.payload = "emoteSend";
                }
                if (message.emoteReceived != null && message.hasOwnProperty("emoteReceived")) {
                    object.emoteReceived = $root.runegambit.v1.EmoteReceived.toObject(message.emoteReceived, options);
                    if (options.oneofs)
                        object.payload = "emoteReceived";
                }
                return object;
            };

            /**
             * Converts this Envelope to JSON.
             * @function toJSON
             * @memberof runegambit.v1.Envelope
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Envelope.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Envelope
             * @function getTypeUrl
             * @memberof runegambit.v1.Envelope
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Envelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.Envelope";
            };

            return Envelope;
        })();

        v1.PlayerView = (function() {

            /**
             * Properties of a PlayerView.
             * @memberof runegambit.v1
             * @interface IPlayerView
             * @property {number|null} [currentTurnIdx] PlayerView currentTurnIdx
             * @property {number|null} [currentPlayerSlot] PlayerView currentPlayerSlot
             * @property {string|null} [status] PlayerView status
             * @property {number|null} [yourSlot] PlayerView yourSlot
             * @property {string|null} [yourStateJson] PlayerView yourStateJson
             */

            /**
             * Constructs a new PlayerView.
             * @memberof runegambit.v1
             * @classdesc Represents a PlayerView.
             * @implements IPlayerView
             * @constructor
             * @param {runegambit.v1.IPlayerView=} [properties] Properties to set
             */
            function PlayerView(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PlayerView currentTurnIdx.
             * @member {number} currentTurnIdx
             * @memberof runegambit.v1.PlayerView
             * @instance
             */
            PlayerView.prototype.currentTurnIdx = 0;

            /**
             * PlayerView currentPlayerSlot.
             * @member {number} currentPlayerSlot
             * @memberof runegambit.v1.PlayerView
             * @instance
             */
            PlayerView.prototype.currentPlayerSlot = 0;

            /**
             * PlayerView status.
             * @member {string} status
             * @memberof runegambit.v1.PlayerView
             * @instance
             */
            PlayerView.prototype.status = "";

            /**
             * PlayerView yourSlot.
             * @member {number} yourSlot
             * @memberof runegambit.v1.PlayerView
             * @instance
             */
            PlayerView.prototype.yourSlot = 0;

            /**
             * PlayerView yourStateJson.
             * @member {string} yourStateJson
             * @memberof runegambit.v1.PlayerView
             * @instance
             */
            PlayerView.prototype.yourStateJson = "";

            /**
             * Creates a new PlayerView instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {runegambit.v1.IPlayerView=} [properties] Properties to set
             * @returns {runegambit.v1.PlayerView} PlayerView instance
             */
            PlayerView.create = function create(properties) {
                return new PlayerView(properties);
            };

            /**
             * Encodes the specified PlayerView message. Does not implicitly {@link runegambit.v1.PlayerView.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {runegambit.v1.IPlayerView} message PlayerView message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerView.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.currentTurnIdx != null && Object.hasOwnProperty.call(message, "currentTurnIdx"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.currentTurnIdx);
                if (message.currentPlayerSlot != null && Object.hasOwnProperty.call(message, "currentPlayerSlot"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.currentPlayerSlot);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.status);
                if (message.yourSlot != null && Object.hasOwnProperty.call(message, "yourSlot"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.yourSlot);
                if (message.yourStateJson != null && Object.hasOwnProperty.call(message, "yourStateJson"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.yourStateJson);
                return writer;
            };

            /**
             * Encodes the specified PlayerView message, length delimited. Does not implicitly {@link runegambit.v1.PlayerView.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {runegambit.v1.IPlayerView} message PlayerView message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerView.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlayerView message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.PlayerView} PlayerView
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerView.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.PlayerView();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.currentTurnIdx = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.currentPlayerSlot = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.status = reader.string();
                            break;
                        }
                    case 4: {
                            message.yourSlot = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.yourStateJson = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PlayerView message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.PlayerView} PlayerView
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerView.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlayerView message.
             * @function verify
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlayerView.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.currentTurnIdx != null && message.hasOwnProperty("currentTurnIdx"))
                    if (!$util.isInteger(message.currentTurnIdx))
                        return "currentTurnIdx: integer expected";
                if (message.currentPlayerSlot != null && message.hasOwnProperty("currentPlayerSlot"))
                    if (!$util.isInteger(message.currentPlayerSlot))
                        return "currentPlayerSlot: integer expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isString(message.status))
                        return "status: string expected";
                if (message.yourSlot != null && message.hasOwnProperty("yourSlot"))
                    if (!$util.isInteger(message.yourSlot))
                        return "yourSlot: integer expected";
                if (message.yourStateJson != null && message.hasOwnProperty("yourStateJson"))
                    if (!$util.isString(message.yourStateJson))
                        return "yourStateJson: string expected";
                return null;
            };

            /**
             * Creates a PlayerView message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.PlayerView} PlayerView
             */
            PlayerView.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.PlayerView)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.PlayerView();
                if (object.currentTurnIdx != null)
                    message.currentTurnIdx = object.currentTurnIdx >>> 0;
                if (object.currentPlayerSlot != null)
                    message.currentPlayerSlot = object.currentPlayerSlot >>> 0;
                if (object.status != null)
                    message.status = String(object.status);
                if (object.yourSlot != null)
                    message.yourSlot = object.yourSlot >>> 0;
                if (object.yourStateJson != null)
                    message.yourStateJson = String(object.yourStateJson);
                return message;
            };

            /**
             * Creates a plain object from a PlayerView message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {runegambit.v1.PlayerView} message PlayerView
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlayerView.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.currentTurnIdx = 0;
                    object.currentPlayerSlot = 0;
                    object.status = "";
                    object.yourSlot = 0;
                    object.yourStateJson = "";
                }
                if (message.currentTurnIdx != null && message.hasOwnProperty("currentTurnIdx"))
                    object.currentTurnIdx = message.currentTurnIdx;
                if (message.currentPlayerSlot != null && message.hasOwnProperty("currentPlayerSlot"))
                    object.currentPlayerSlot = message.currentPlayerSlot;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.yourSlot != null && message.hasOwnProperty("yourSlot"))
                    object.yourSlot = message.yourSlot;
                if (message.yourStateJson != null && message.hasOwnProperty("yourStateJson"))
                    object.yourStateJson = message.yourStateJson;
                return object;
            };

            /**
             * Converts this PlayerView to JSON.
             * @function toJSON
             * @memberof runegambit.v1.PlayerView
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlayerView.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PlayerView
             * @function getTypeUrl
             * @memberof runegambit.v1.PlayerView
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PlayerView.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.PlayerView";
            };

            return PlayerView;
        })();

        v1.TurnApplied = (function() {

            /**
             * Properties of a TurnApplied.
             * @memberof runegambit.v1
             * @interface ITurnApplied
             * @property {runegambit.v1.IPlayerView|null} [yourState] TurnApplied yourState
             */

            /**
             * Constructs a new TurnApplied.
             * @memberof runegambit.v1
             * @classdesc Represents a TurnApplied.
             * @implements ITurnApplied
             * @constructor
             * @param {runegambit.v1.ITurnApplied=} [properties] Properties to set
             */
            function TurnApplied(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TurnApplied yourState.
             * @member {runegambit.v1.IPlayerView|null|undefined} yourState
             * @memberof runegambit.v1.TurnApplied
             * @instance
             */
            TurnApplied.prototype.yourState = null;

            /**
             * Creates a new TurnApplied instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {runegambit.v1.ITurnApplied=} [properties] Properties to set
             * @returns {runegambit.v1.TurnApplied} TurnApplied instance
             */
            TurnApplied.create = function create(properties) {
                return new TurnApplied(properties);
            };

            /**
             * Encodes the specified TurnApplied message. Does not implicitly {@link runegambit.v1.TurnApplied.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {runegambit.v1.ITurnApplied} message TurnApplied message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TurnApplied.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.yourState != null && Object.hasOwnProperty.call(message, "yourState"))
                    $root.runegambit.v1.PlayerView.encode(message.yourState, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified TurnApplied message, length delimited. Does not implicitly {@link runegambit.v1.TurnApplied.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {runegambit.v1.ITurnApplied} message TurnApplied message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TurnApplied.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TurnApplied message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.TurnApplied} TurnApplied
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TurnApplied.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.TurnApplied();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.yourState = $root.runegambit.v1.PlayerView.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TurnApplied message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.TurnApplied} TurnApplied
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TurnApplied.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TurnApplied message.
             * @function verify
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TurnApplied.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.yourState != null && message.hasOwnProperty("yourState")) {
                    let error = $root.runegambit.v1.PlayerView.verify(message.yourState, long + 1);
                    if (error)
                        return "yourState." + error;
                }
                return null;
            };

            /**
             * Creates a TurnApplied message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.TurnApplied} TurnApplied
             */
            TurnApplied.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.TurnApplied)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.TurnApplied();
                if (object.yourState != null) {
                    if (typeof object.yourState !== "object")
                        throw TypeError(".runegambit.v1.TurnApplied.yourState: object expected");
                    message.yourState = $root.runegambit.v1.PlayerView.fromObject(object.yourState, long + 1);
                }
                return message;
            };

            /**
             * Creates a plain object from a TurnApplied message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {runegambit.v1.TurnApplied} message TurnApplied
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TurnApplied.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.yourState = null;
                if (message.yourState != null && message.hasOwnProperty("yourState"))
                    object.yourState = $root.runegambit.v1.PlayerView.toObject(message.yourState, options);
                return object;
            };

            /**
             * Converts this TurnApplied to JSON.
             * @function toJSON
             * @memberof runegambit.v1.TurnApplied
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TurnApplied.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TurnApplied
             * @function getTypeUrl
             * @memberof runegambit.v1.TurnApplied
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TurnApplied.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.TurnApplied";
            };

            return TurnApplied;
        })();

        v1.StateSnapshot = (function() {

            /**
             * Properties of a StateSnapshot.
             * @memberof runegambit.v1
             * @interface IStateSnapshot
             * @property {runegambit.v1.IPlayerView|null} [yourState] StateSnapshot yourState
             */

            /**
             * Constructs a new StateSnapshot.
             * @memberof runegambit.v1
             * @classdesc Represents a StateSnapshot.
             * @implements IStateSnapshot
             * @constructor
             * @param {runegambit.v1.IStateSnapshot=} [properties] Properties to set
             */
            function StateSnapshot(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StateSnapshot yourState.
             * @member {runegambit.v1.IPlayerView|null|undefined} yourState
             * @memberof runegambit.v1.StateSnapshot
             * @instance
             */
            StateSnapshot.prototype.yourState = null;

            /**
             * Creates a new StateSnapshot instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {runegambit.v1.IStateSnapshot=} [properties] Properties to set
             * @returns {runegambit.v1.StateSnapshot} StateSnapshot instance
             */
            StateSnapshot.create = function create(properties) {
                return new StateSnapshot(properties);
            };

            /**
             * Encodes the specified StateSnapshot message. Does not implicitly {@link runegambit.v1.StateSnapshot.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {runegambit.v1.IStateSnapshot} message StateSnapshot message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StateSnapshot.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.yourState != null && Object.hasOwnProperty.call(message, "yourState"))
                    $root.runegambit.v1.PlayerView.encode(message.yourState, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified StateSnapshot message, length delimited. Does not implicitly {@link runegambit.v1.StateSnapshot.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {runegambit.v1.IStateSnapshot} message StateSnapshot message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StateSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StateSnapshot message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.StateSnapshot} StateSnapshot
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StateSnapshot.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.StateSnapshot();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.yourState = $root.runegambit.v1.PlayerView.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StateSnapshot message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.StateSnapshot} StateSnapshot
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StateSnapshot.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StateSnapshot message.
             * @function verify
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StateSnapshot.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.yourState != null && message.hasOwnProperty("yourState")) {
                    let error = $root.runegambit.v1.PlayerView.verify(message.yourState, long + 1);
                    if (error)
                        return "yourState." + error;
                }
                return null;
            };

            /**
             * Creates a StateSnapshot message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.StateSnapshot} StateSnapshot
             */
            StateSnapshot.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.StateSnapshot)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.StateSnapshot();
                if (object.yourState != null) {
                    if (typeof object.yourState !== "object")
                        throw TypeError(".runegambit.v1.StateSnapshot.yourState: object expected");
                    message.yourState = $root.runegambit.v1.PlayerView.fromObject(object.yourState, long + 1);
                }
                return message;
            };

            /**
             * Creates a plain object from a StateSnapshot message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {runegambit.v1.StateSnapshot} message StateSnapshot
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StateSnapshot.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.yourState = null;
                if (message.yourState != null && message.hasOwnProperty("yourState"))
                    object.yourState = $root.runegambit.v1.PlayerView.toObject(message.yourState, options);
                return object;
            };

            /**
             * Converts this StateSnapshot to JSON.
             * @function toJSON
             * @memberof runegambit.v1.StateSnapshot
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StateSnapshot.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StateSnapshot
             * @function getTypeUrl
             * @memberof runegambit.v1.StateSnapshot
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StateSnapshot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.StateSnapshot";
            };

            return StateSnapshot;
        })();

        v1.ErrorEnvelope = (function() {

            /**
             * Properties of an ErrorEnvelope.
             * @memberof runegambit.v1
             * @interface IErrorEnvelope
             * @property {string|null} [code] ErrorEnvelope code
             * @property {string|null} [message] ErrorEnvelope message
             * @property {string|null} [stage] ErrorEnvelope stage
             * @property {string|null} [reason] ErrorEnvelope reason
             */

            /**
             * Constructs a new ErrorEnvelope.
             * @memberof runegambit.v1
             * @classdesc Represents an ErrorEnvelope.
             * @implements IErrorEnvelope
             * @constructor
             * @param {runegambit.v1.IErrorEnvelope=} [properties] Properties to set
             */
            function ErrorEnvelope(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ErrorEnvelope code.
             * @member {string} code
             * @memberof runegambit.v1.ErrorEnvelope
             * @instance
             */
            ErrorEnvelope.prototype.code = "";

            /**
             * ErrorEnvelope message.
             * @member {string} message
             * @memberof runegambit.v1.ErrorEnvelope
             * @instance
             */
            ErrorEnvelope.prototype.message = "";

            /**
             * ErrorEnvelope stage.
             * @member {string} stage
             * @memberof runegambit.v1.ErrorEnvelope
             * @instance
             */
            ErrorEnvelope.prototype.stage = "";

            /**
             * ErrorEnvelope reason.
             * @member {string} reason
             * @memberof runegambit.v1.ErrorEnvelope
             * @instance
             */
            ErrorEnvelope.prototype.reason = "";

            /**
             * Creates a new ErrorEnvelope instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {runegambit.v1.IErrorEnvelope=} [properties] Properties to set
             * @returns {runegambit.v1.ErrorEnvelope} ErrorEnvelope instance
             */
            ErrorEnvelope.create = function create(properties) {
                return new ErrorEnvelope(properties);
            };

            /**
             * Encodes the specified ErrorEnvelope message. Does not implicitly {@link runegambit.v1.ErrorEnvelope.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {runegambit.v1.IErrorEnvelope} message ErrorEnvelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ErrorEnvelope.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                if (message.stage != null && Object.hasOwnProperty.call(message, "stage"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.stage);
                if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.reason);
                return writer;
            };

            /**
             * Encodes the specified ErrorEnvelope message, length delimited. Does not implicitly {@link runegambit.v1.ErrorEnvelope.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {runegambit.v1.IErrorEnvelope} message ErrorEnvelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ErrorEnvelope.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ErrorEnvelope message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.ErrorEnvelope} ErrorEnvelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ErrorEnvelope.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.ErrorEnvelope();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.code = reader.string();
                            break;
                        }
                    case 2: {
                            message.message = reader.string();
                            break;
                        }
                    case 3: {
                            message.stage = reader.string();
                            break;
                        }
                    case 4: {
                            message.reason = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ErrorEnvelope message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.ErrorEnvelope} ErrorEnvelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ErrorEnvelope.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ErrorEnvelope message.
             * @function verify
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ErrorEnvelope.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.stage != null && message.hasOwnProperty("stage"))
                    if (!$util.isString(message.stage))
                        return "stage: string expected";
                if (message.reason != null && message.hasOwnProperty("reason"))
                    if (!$util.isString(message.reason))
                        return "reason: string expected";
                return null;
            };

            /**
             * Creates an ErrorEnvelope message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.ErrorEnvelope} ErrorEnvelope
             */
            ErrorEnvelope.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.ErrorEnvelope)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.ErrorEnvelope();
                if (object.code != null)
                    message.code = String(object.code);
                if (object.message != null)
                    message.message = String(object.message);
                if (object.stage != null)
                    message.stage = String(object.stage);
                if (object.reason != null)
                    message.reason = String(object.reason);
                return message;
            };

            /**
             * Creates a plain object from an ErrorEnvelope message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {runegambit.v1.ErrorEnvelope} message ErrorEnvelope
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ErrorEnvelope.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.code = "";
                    object.message = "";
                    object.stage = "";
                    object.reason = "";
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.stage != null && message.hasOwnProperty("stage"))
                    object.stage = message.stage;
                if (message.reason != null && message.hasOwnProperty("reason"))
                    object.reason = message.reason;
                return object;
            };

            /**
             * Converts this ErrorEnvelope to JSON.
             * @function toJSON
             * @memberof runegambit.v1.ErrorEnvelope
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ErrorEnvelope.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ErrorEnvelope
             * @function getTypeUrl
             * @memberof runegambit.v1.ErrorEnvelope
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ErrorEnvelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.ErrorEnvelope";
            };

            return ErrorEnvelope;
        })();

        v1.Ping = (function() {

            /**
             * Properties of a Ping.
             * @memberof runegambit.v1
             * @interface IPing
             * @property {number|Long|null} [ts] Ping ts
             */

            /**
             * Constructs a new Ping.
             * @memberof runegambit.v1
             * @classdesc Represents a Ping.
             * @implements IPing
             * @constructor
             * @param {runegambit.v1.IPing=} [properties] Properties to set
             */
            function Ping(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Ping ts.
             * @member {number|Long} ts
             * @memberof runegambit.v1.Ping
             * @instance
             */
            Ping.prototype.ts = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new Ping instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.Ping
             * @static
             * @param {runegambit.v1.IPing=} [properties] Properties to set
             * @returns {runegambit.v1.Ping} Ping instance
             */
            Ping.create = function create(properties) {
                return new Ping(properties);
            };

            /**
             * Encodes the specified Ping message. Does not implicitly {@link runegambit.v1.Ping.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.Ping
             * @static
             * @param {runegambit.v1.IPing} message Ping message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Ping.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.ts);
                return writer;
            };

            /**
             * Encodes the specified Ping message, length delimited. Does not implicitly {@link runegambit.v1.Ping.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.Ping
             * @static
             * @param {runegambit.v1.IPing} message Ping message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Ping.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Ping message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.Ping
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.Ping} Ping
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Ping.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.Ping();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.ts = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Ping message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.Ping
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.Ping} Ping
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Ping.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Ping message.
             * @function verify
             * @memberof runegambit.v1.Ping
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Ping.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.ts != null && message.hasOwnProperty("ts"))
                    if (!$util.isInteger(message.ts) && !(message.ts && $util.isInteger(message.ts.low) && $util.isInteger(message.ts.high)))
                        return "ts: integer|Long expected";
                return null;
            };

            /**
             * Creates a Ping message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.Ping
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.Ping} Ping
             */
            Ping.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.Ping)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.Ping();
                if (object.ts != null)
                    if ($util.Long)
                        (message.ts = $util.Long.fromValue(object.ts)).unsigned = true;
                    else if (typeof object.ts === "string")
                        message.ts = parseInt(object.ts, 10);
                    else if (typeof object.ts === "number")
                        message.ts = object.ts;
                    else if (typeof object.ts === "object")
                        message.ts = new $util.LongBits(object.ts.low >>> 0, object.ts.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a Ping message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.Ping
             * @static
             * @param {runegambit.v1.Ping} message Ping
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Ping.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.ts = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.ts = options.longs === String ? "0" : 0;
                if (message.ts != null && message.hasOwnProperty("ts"))
                    if (typeof message.ts === "number")
                        object.ts = options.longs === String ? String(message.ts) : message.ts;
                    else
                        object.ts = options.longs === String ? $util.Long.prototype.toString.call(message.ts) : options.longs === Number ? new $util.LongBits(message.ts.low >>> 0, message.ts.high >>> 0).toNumber(true) : message.ts;
                return object;
            };

            /**
             * Converts this Ping to JSON.
             * @function toJSON
             * @memberof runegambit.v1.Ping
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Ping.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Ping
             * @function getTypeUrl
             * @memberof runegambit.v1.Ping
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Ping.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.Ping";
            };

            return Ping;
        })();

        v1.Pong = (function() {

            /**
             * Properties of a Pong.
             * @memberof runegambit.v1
             * @interface IPong
             * @property {number|Long|null} [ts] Pong ts
             */

            /**
             * Constructs a new Pong.
             * @memberof runegambit.v1
             * @classdesc Represents a Pong.
             * @implements IPong
             * @constructor
             * @param {runegambit.v1.IPong=} [properties] Properties to set
             */
            function Pong(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Pong ts.
             * @member {number|Long} ts
             * @memberof runegambit.v1.Pong
             * @instance
             */
            Pong.prototype.ts = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new Pong instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.Pong
             * @static
             * @param {runegambit.v1.IPong=} [properties] Properties to set
             * @returns {runegambit.v1.Pong} Pong instance
             */
            Pong.create = function create(properties) {
                return new Pong(properties);
            };

            /**
             * Encodes the specified Pong message. Does not implicitly {@link runegambit.v1.Pong.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.Pong
             * @static
             * @param {runegambit.v1.IPong} message Pong message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Pong.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.ts);
                return writer;
            };

            /**
             * Encodes the specified Pong message, length delimited. Does not implicitly {@link runegambit.v1.Pong.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.Pong
             * @static
             * @param {runegambit.v1.IPong} message Pong message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Pong.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Pong message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.Pong
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.Pong} Pong
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Pong.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.Pong();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.ts = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Pong message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.Pong
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.Pong} Pong
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Pong.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Pong message.
             * @function verify
             * @memberof runegambit.v1.Pong
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Pong.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.ts != null && message.hasOwnProperty("ts"))
                    if (!$util.isInteger(message.ts) && !(message.ts && $util.isInteger(message.ts.low) && $util.isInteger(message.ts.high)))
                        return "ts: integer|Long expected";
                return null;
            };

            /**
             * Creates a Pong message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.Pong
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.Pong} Pong
             */
            Pong.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.Pong)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.Pong();
                if (object.ts != null)
                    if ($util.Long)
                        (message.ts = $util.Long.fromValue(object.ts)).unsigned = true;
                    else if (typeof object.ts === "string")
                        message.ts = parseInt(object.ts, 10);
                    else if (typeof object.ts === "number")
                        message.ts = object.ts;
                    else if (typeof object.ts === "object")
                        message.ts = new $util.LongBits(object.ts.low >>> 0, object.ts.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a Pong message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.Pong
             * @static
             * @param {runegambit.v1.Pong} message Pong
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Pong.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.ts = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.ts = options.longs === String ? "0" : 0;
                if (message.ts != null && message.hasOwnProperty("ts"))
                    if (typeof message.ts === "number")
                        object.ts = options.longs === String ? String(message.ts) : message.ts;
                    else
                        object.ts = options.longs === String ? $util.Long.prototype.toString.call(message.ts) : options.longs === Number ? new $util.LongBits(message.ts.low >>> 0, message.ts.high >>> 0).toNumber(true) : message.ts;
                return object;
            };

            /**
             * Converts this Pong to JSON.
             * @function toJSON
             * @memberof runegambit.v1.Pong
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Pong.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Pong
             * @function getTypeUrl
             * @memberof runegambit.v1.Pong
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Pong.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.Pong";
            };

            return Pong;
        })();

        v1.EmoteSend = (function() {

            /**
             * Properties of an EmoteSend.
             * @memberof runegambit.v1
             * @interface IEmoteSend
             * @property {string|null} [emoteId] EmoteSend emoteId
             */

            /**
             * Constructs a new EmoteSend.
             * @memberof runegambit.v1
             * @classdesc Represents an EmoteSend.
             * @implements IEmoteSend
             * @constructor
             * @param {runegambit.v1.IEmoteSend=} [properties] Properties to set
             */
            function EmoteSend(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EmoteSend emoteId.
             * @member {string} emoteId
             * @memberof runegambit.v1.EmoteSend
             * @instance
             */
            EmoteSend.prototype.emoteId = "";

            /**
             * Creates a new EmoteSend instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {runegambit.v1.IEmoteSend=} [properties] Properties to set
             * @returns {runegambit.v1.EmoteSend} EmoteSend instance
             */
            EmoteSend.create = function create(properties) {
                return new EmoteSend(properties);
            };

            /**
             * Encodes the specified EmoteSend message. Does not implicitly {@link runegambit.v1.EmoteSend.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {runegambit.v1.IEmoteSend} message EmoteSend message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmoteSend.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.emoteId != null && Object.hasOwnProperty.call(message, "emoteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.emoteId);
                return writer;
            };

            /**
             * Encodes the specified EmoteSend message, length delimited. Does not implicitly {@link runegambit.v1.EmoteSend.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {runegambit.v1.IEmoteSend} message EmoteSend message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmoteSend.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmoteSend message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.EmoteSend} EmoteSend
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmoteSend.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.EmoteSend();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.emoteId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmoteSend message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.EmoteSend} EmoteSend
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmoteSend.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmoteSend message.
             * @function verify
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmoteSend.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.emoteId != null && message.hasOwnProperty("emoteId"))
                    if (!$util.isString(message.emoteId))
                        return "emoteId: string expected";
                return null;
            };

            /**
             * Creates an EmoteSend message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.EmoteSend} EmoteSend
             */
            EmoteSend.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.EmoteSend)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.EmoteSend();
                if (object.emoteId != null)
                    message.emoteId = String(object.emoteId);
                return message;
            };

            /**
             * Creates a plain object from an EmoteSend message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {runegambit.v1.EmoteSend} message EmoteSend
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmoteSend.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.emoteId = "";
                if (message.emoteId != null && message.hasOwnProperty("emoteId"))
                    object.emoteId = message.emoteId;
                return object;
            };

            /**
             * Converts this EmoteSend to JSON.
             * @function toJSON
             * @memberof runegambit.v1.EmoteSend
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmoteSend.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmoteSend
             * @function getTypeUrl
             * @memberof runegambit.v1.EmoteSend
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmoteSend.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.EmoteSend";
            };

            return EmoteSend;
        })();

        v1.EmoteReceived = (function() {

            /**
             * Properties of an EmoteReceived.
             * @memberof runegambit.v1
             * @interface IEmoteReceived
             * @property {string|null} [emoteId] EmoteReceived emoteId
             * @property {number|null} [senderSlot] EmoteReceived senderSlot
             * @property {number|Long|null} [sentAt] EmoteReceived sentAt
             */

            /**
             * Constructs a new EmoteReceived.
             * @memberof runegambit.v1
             * @classdesc Represents an EmoteReceived.
             * @implements IEmoteReceived
             * @constructor
             * @param {runegambit.v1.IEmoteReceived=} [properties] Properties to set
             */
            function EmoteReceived(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EmoteReceived emoteId.
             * @member {string} emoteId
             * @memberof runegambit.v1.EmoteReceived
             * @instance
             */
            EmoteReceived.prototype.emoteId = "";

            /**
             * EmoteReceived senderSlot.
             * @member {number} senderSlot
             * @memberof runegambit.v1.EmoteReceived
             * @instance
             */
            EmoteReceived.prototype.senderSlot = 0;

            /**
             * EmoteReceived sentAt.
             * @member {number|Long} sentAt
             * @memberof runegambit.v1.EmoteReceived
             * @instance
             */
            EmoteReceived.prototype.sentAt = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new EmoteReceived instance using the specified properties.
             * @function create
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {runegambit.v1.IEmoteReceived=} [properties] Properties to set
             * @returns {runegambit.v1.EmoteReceived} EmoteReceived instance
             */
            EmoteReceived.create = function create(properties) {
                return new EmoteReceived(properties);
            };

            /**
             * Encodes the specified EmoteReceived message. Does not implicitly {@link runegambit.v1.EmoteReceived.verify|verify} messages.
             * @function encode
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {runegambit.v1.IEmoteReceived} message EmoteReceived message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmoteReceived.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.emoteId != null && Object.hasOwnProperty.call(message, "emoteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.emoteId);
                if (message.senderSlot != null && Object.hasOwnProperty.call(message, "senderSlot"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.senderSlot);
                if (message.sentAt != null && Object.hasOwnProperty.call(message, "sentAt"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.sentAt);
                return writer;
            };

            /**
             * Encodes the specified EmoteReceived message, length delimited. Does not implicitly {@link runegambit.v1.EmoteReceived.verify|verify} messages.
             * @function encodeDelimited
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {runegambit.v1.IEmoteReceived} message EmoteReceived message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmoteReceived.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmoteReceived message from the specified reader or buffer.
             * @function decode
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {runegambit.v1.EmoteReceived} EmoteReceived
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmoteReceived.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.runegambit.v1.EmoteReceived();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.emoteId = reader.string();
                            break;
                        }
                    case 2: {
                            message.senderSlot = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.sentAt = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmoteReceived message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {runegambit.v1.EmoteReceived} EmoteReceived
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmoteReceived.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmoteReceived message.
             * @function verify
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmoteReceived.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.emoteId != null && message.hasOwnProperty("emoteId"))
                    if (!$util.isString(message.emoteId))
                        return "emoteId: string expected";
                if (message.senderSlot != null && message.hasOwnProperty("senderSlot"))
                    if (!$util.isInteger(message.senderSlot))
                        return "senderSlot: integer expected";
                if (message.sentAt != null && message.hasOwnProperty("sentAt"))
                    if (!$util.isInteger(message.sentAt) && !(message.sentAt && $util.isInteger(message.sentAt.low) && $util.isInteger(message.sentAt.high)))
                        return "sentAt: integer|Long expected";
                return null;
            };

            /**
             * Creates an EmoteReceived message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {runegambit.v1.EmoteReceived} EmoteReceived
             */
            EmoteReceived.fromObject = function fromObject(object, long) {
                if (object instanceof $root.runegambit.v1.EmoteReceived)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.runegambit.v1.EmoteReceived();
                if (object.emoteId != null)
                    message.emoteId = String(object.emoteId);
                if (object.senderSlot != null)
                    message.senderSlot = object.senderSlot >>> 0;
                if (object.sentAt != null)
                    if ($util.Long)
                        (message.sentAt = $util.Long.fromValue(object.sentAt)).unsigned = true;
                    else if (typeof object.sentAt === "string")
                        message.sentAt = parseInt(object.sentAt, 10);
                    else if (typeof object.sentAt === "number")
                        message.sentAt = object.sentAt;
                    else if (typeof object.sentAt === "object")
                        message.sentAt = new $util.LongBits(object.sentAt.low >>> 0, object.sentAt.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from an EmoteReceived message. Also converts values to other types if specified.
             * @function toObject
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {runegambit.v1.EmoteReceived} message EmoteReceived
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmoteReceived.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.emoteId = "";
                    object.senderSlot = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.sentAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.sentAt = options.longs === String ? "0" : 0;
                }
                if (message.emoteId != null && message.hasOwnProperty("emoteId"))
                    object.emoteId = message.emoteId;
                if (message.senderSlot != null && message.hasOwnProperty("senderSlot"))
                    object.senderSlot = message.senderSlot;
                if (message.sentAt != null && message.hasOwnProperty("sentAt"))
                    if (typeof message.sentAt === "number")
                        object.sentAt = options.longs === String ? String(message.sentAt) : message.sentAt;
                    else
                        object.sentAt = options.longs === String ? $util.Long.prototype.toString.call(message.sentAt) : options.longs === Number ? new $util.LongBits(message.sentAt.low >>> 0, message.sentAt.high >>> 0).toNumber(true) : message.sentAt;
                return object;
            };

            /**
             * Converts this EmoteReceived to JSON.
             * @function toJSON
             * @memberof runegambit.v1.EmoteReceived
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmoteReceived.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmoteReceived
             * @function getTypeUrl
             * @memberof runegambit.v1.EmoteReceived
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmoteReceived.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/runegambit.v1.EmoteReceived";
            };

            return EmoteReceived;
        })();

        return v1;
    })();

    return runegambit;
})();

export { $root as default };
